module.exports = __webpack_public_path__ + "joy-static/media/ShieldIcon.ad693490.png";